export const DRIVING_TYPE = {
    A1: 'a1',
    A2: 'a2',
    B1: 'b1',
    B2: 'b2',
};

export const DRIVING_TAG = {
    1: 'Khái niệm và quy tắc',
    2: 'Văn hóa và đạo đức',
    3: 'Kỹ thuật lái xe',
    4: 'Biển báo đường bộ',
    5: 'Sa hình',
    6: 'Câu hỏi điểm liệt',
    7: 'Cấu tạo và sửa chữa',
    8: 'Nghiệp vụ vận tải',
};

export const DRIVING_STATE = {
    CREATED: 0,
    WAITING_PAYMENT: 2,
    WAITING_CHANGE: 1,
    APPROVED: 5,
    HAS_FILE_1: 8,
    HAS_FILE_2: 9,
    HEALTH_CHECKED: 6,
    WAITING_FOR_SCHEDULE: 7,
    FINISHED: 3,
    RECEIVED: 10,
    CANCELED: 4,
}

export const DRIVING_STATE_LABEL = {
    [DRIVING_STATE.CREATED]: 'Đã tạo',
    [DRIVING_STATE.WAITING_PAYMENT]: 'Chờ thanh toán',
    [DRIVING_STATE.WAITING_CHANGE]: 'Chờ cập nhật',
    [DRIVING_STATE.APPROVED]: 'Đã duyệt',
    [DRIVING_STATE.HAS_FILE_1]: 'Đã có hồ sơ',
    [DRIVING_STATE.HAS_FILE_2]: 'Đã có hồ sơ',
    [DRIVING_STATE.HEALTH_CHECKED]: 'Đã khám sức khỏe',
    [DRIVING_STATE.WAITING_FOR_SCHEDULE]: 'Chờ lịch thi',
    [DRIVING_STATE.FINISHED]: 'Đã hoàn thành',
    [DRIVING_STATE.RECEIVED]: 'Đã nhận',
    [DRIVING_STATE.CANCELED]: 'Đã hủy',
};
